import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/card.css'

import { Candidate } from '../Candidate'

export function List(list) {
  const l = list.list
  return (
    <div className='ui raised card' id={`list-${l.number}`}>
      <div className='content'>
        <div className='header'>{l.name}</div>
        <p>
          <br />
        </p>
        {l.candidates.map(c => {
          return <Candidate candidate={c} key={c.name} />
        })}
      </div>
    </div>
  )
}
